export default __webpack_public_path__ + "static/media/TV2.2b40d038.svg";